import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import Icon from 'discada/dist/Icon'

import Header from 'components/VRP/Header'
import Gallery from 'components/VRP/Gallery'
import { getEntity } from 'selectors/entitySelectors'
import {
  getQuote,
  getBestProgram,
  getBestPayment,
  getQuoteValue,
  getAdditionItemsForContractDetails,
  getRebateItemsForContractDetails,
  getRebateSumForContractDetails,
  getAdditionsTotalForContractDetails,
  getDiscountItemsForContractDetails,
  getDiscountTotalForContractDetails,
  getFeeItemsForContractDetails,
  getDealerCashItemsForContractDetails,
  showPaymentRange,
} from 'selectors/quoteSelectors'

import { FIELDS as F } from 'components/Quote/contractDetailsFields' // TODO move
import Menuing from 'components/widgets/Menuing'
import { getBankByCode } from 'selectors/appStatusSelectors'

import PricingCard from 'components/VRP/PricingCard'

export function ContractBlockMenuing(props) {
  let { programInfo, quote, items } = props

  return (
    <Menuing
      noCheck
      items={items
        .filter(i => i)
        .map(i => ({
          ...i,
          hide:
            (typeof i.hide === 'function' &&
              i.hide(programInfo, quote, props)) ||
            i.hide === true,
        }))}
      valueRenderer={c => c.value(programInfo, quote, props)}
      labelRenderer={c =>
        typeof c.name === 'function'
          ? c.name(programInfo, quote, props)
          : c.name
      }
    />
  )
}

export function ContractBlockPreso(props) {
  let { className, children = () => {}, title, icon, width = 'half' } = props,
    body = typeof children === 'function' ? children(props) : children

  if (isEmpty(body)) return null

  return (
    <div className={c('contract-details-block', className, width)}>
      {title && (
        <div className="contract-details-block-title">
          {icon && <Icon icon={icon} />} {title}
        </div>
      )}
      <div className="contract-details-block-content">{body}</div>
    </div>
  )
}

function attachProgram(state, op) {
  let { vehicleId, quoteId, mode } = op,
    vId = vehicleId,
    qId = quoteId,
    program = getBestProgram(state, vId, qId, mode),
    dealerIncentivesReducePrice = getQuoteValue(
      state,
      vId,
      qId,
      'dealerIncentivesReducePrice',
    )

  return {
    ...op,
    getBankByCode: code => getBankByCode(state, code),
    vehicle: getEntity(state, vId),
    quote: getQuote(state, vId, qId, mode),
    down: getQuoteValue(state, vId, qId, 'down'),
    term: getQuoteValue(state, vId, qId, `${mode}Term`),
    program,
    programInfo: get(program, 'programInfo', {}),
    combinedAddsTotal: getAdditionsTotalForContractDetails(state, vId, qId),
    addsList: getAdditionItemsForContractDetails(state, vId, qId),
    rebatesList: getRebateItemsForContractDetails(state, vId, qId, mode, false),
    rebatesTotal: getRebateSumForContractDetails(state, vId, qId, mode),
    dealerCashItems: getDealerCashItemsForContractDetails(
      state,
      vId,
      qId,
      mode,
      true,
    ),
    dealerCashTotal: getRebateSumForContractDetails(
      state,
      vId,
      qId,
      mode,
      true,
    ),
    discountItems: getDiscountItemsForContractDetails(state, vId, qId),
    discountTotal: getDiscountTotalForContractDetails(state, vId, qId),
    dealerIncentivesReducePrice,
    monthlyPayment: getBestPayment(state, vId, qId, mode),
    feesList: getFeeItemsForContractDetails(state, vId, qId, mode),
    showRange: showPaymentRange(state, op.vehicleId, op.quoteId),
  }
}

export const ContractBlock = connect(attachProgram)(ContractBlockPreso)

export default ContractBlock

////////////////////////////////////////////////////////////////////////////////////////////

export function RetailPricing(props) {
  let pricing = props => {
    let {
        addsList,
        rebatesList,
        discountItems,
        dealerIncentivesReducePrice,
        dealerCashItems,
      } = props,
      items = [
        F.msrp,
        F.price,
        ...addsList,
        ...rebatesList,
        ...(dealerIncentivesReducePrice ? dealerCashItems : []),
        ...discountItems,
        F.freight,
        F.retailSubTotal,
      ]

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="vehicle-pricing">
      {pricing}
    </ContractBlock>
  )
}

export function LeasePricing(props) {
  let pricing = props => {
    let {
        addsList,
        discountItems,
        dealerIncentivesReducePrice,
        dealerCashItems,
      } = props,
      items = [
        F.msrp,
        F.price,
        ...addsList,
        ...discountItems,
        ...(dealerIncentivesReducePrice ? dealerCashItems : []),
        F.freight,
        F.cashDeficiency,
        F.leaseSubTotal,
      ]

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="vehicle-pricing">
      {pricing}
    </ContractBlock>
  )
}

export function VehicleBlock(props) {
  return (
    <ContractBlock {...props} className="vehicle">
      <Header id={props.vehicleId} noswitch />
    </ContractBlock>
  )
}

export function VehicleImage(props) {
  return (
    <ContractBlock {...props} className="vehicle-image">
      {({ vehicle }) => {
        return (
          <img alt="Car Gallery #1" src={get(vehicle, 'images[0].url', null)} />
        )
      }}
    </ContractBlock>
  )
}

export function VehicleGallery(props) {
  return (
    <ContractBlock {...props} className="vehicle vehicle-gallery">
      <Gallery id={props.vehicleId} noswitch />

      <PricingCard
        toggle
        vehicleId={props.vehicleId}
        quoteId={props.quoteId}
        mode={props.mode}
        footer={null}
      />
    </ContractBlock>
  )
}

export function MonthlyPayment(props) {
  return (
    <ContractBlock {...props} className="monthly-payment">
      {() => (
        <PricingCard
          toggle
          vehicleId={props.vehicleId}
          quoteId={props.quoteId}
          mode={props.mode}
          footer={null}
        />
      )}
    </ContractBlock>
  )
}

export function CashEquity(props) {
  let getItems = () => {
    let items = [
      F.tradeAllowance,
      F.tradePayoff,
      F.totalCashDealEquitySum,
    ].filter(x => x)

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="equity">
      {getItems}
    </ContractBlock>
  )
}

export function Equity(props) {
  let getItems = () => {
    let items = [
      F.tradeAllowance,
      F.tradePayoff,
      props.hideCash ? null : F.cash,
      F.equity,
    ].filter(x => x)

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="equity">
      {getItems}
    </ContractBlock>
  )
}

export function LeaseCash(props) {
  let getItems = () => {
    let items = [F.cash, F.tradeAllowance, F.tradePayoff, F.equity]

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="equity">
      {getItems}
    </ContractBlock>
  )
}

export function CCR(props) {
  let getItems = () => {
    let items = [F.ccrFromCash, F.ccrFromEquity, F.rebateDown, F.totalCCR]

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="ccr">
      {getItems}
    </ContractBlock>
  )
}

export function LeaseRebates(props) {
  let getItems = innerProps => {
    if (isEmpty(innerProps.rebatesList)) return null

    let items = [...innerProps.rebatesList, F.totalRebates]

    return <ContractBlockMenuing {...innerProps} items={items} />
  }

  return (
    <ContractBlock {...props} className="rebates">
      {getItems}
    </ContractBlock>
  )
}

export function CashWrapUpBlock(props) {
  let getItems = props => {
    let items = [
      F.cashSubTotal,
      F.totalCashDealEquity,
      F.cashTotalFeesAndTax,
      F.totalCashDealDue,
    ]

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="wrap-up">
      {getItems}
    </ContractBlock>
  )
}

export function RetailBankBlock(props) {
  let getItems = props => {
    let items = [
      F.program,
      F.advance,
      F.term,
      F.rate,
      F.monthlyPayment,
      F.paymentsRemaining,
      F.dueAtSigning,
    ]

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="wrap-up">
      {getItems}
    </ContractBlock>
  )
}

export function CustomerBlock(props) {
  return (
    <ContractBlock {...props} className="customer">
      XXXX XXXX
    </ContractBlock>
  )
}

export function LeaseBankBlock(props) {
  let getItems = props => {
    let items = [
      F.program,
      F.advance,
      F.priceAdjustment,
      F.expectedMileage,
      F.rate,
      F.residual,
      F.monthlyPayment,
      F.term,
      F.paymentsRemaining,
      F.leaseInceptionFees,
      F.preTaxPayment,
      F.leaseUseTax,
      F.payment,
      F.dueAtSigning,
    ]

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="wrap-up">
      {getItems}
    </ContractBlock>
  )
}

export function Signature(props) {
  return (
    <ContractBlock {...props} className="signature-block">
      <Icon icon="times" />
    </ContractBlock>
  )
}

export function RetailTaxesAndFees(props) {
  let getItems = props => {
    let { feesList } = props,
      items = [
        ...feesList,
        F.njSupplementalTitleFee,
        F.wasteTireFee,
        F.salesTax,
        F.cityTax,
        F.calculatedRegistrationFee,
        F.docStampTax,
        F.invetoryTax,
        F.loanCustomFeeTax,
        F.loanRebateTaxes,
        F.inventoryTax,
        F.loanTotalFeesAndTax,
      ]

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="fees-taxes">
      {getItems}
    </ContractBlock>
  )
}

export function LeaseTaxesAndFees(props) {
  let getItems = props => {
    let { feesList } = props,
      items = [
        F.acqFee,
        F.securityDeposit,
        ...feesList,
        F.calculatedRegistrationFee,
        F.njSupplementalTitleFee,
        F.wasteTireFee,
        F.salesTax,
        F.cityTax,
        F.docStampTax,
        F.downPaymentTax,
        F.leaseCustomFeeTax,
        F.inventoryTax,
        F.leaseTotalFeesAndTax,
      ]

    return <ContractBlockMenuing {...props} items={items} />
  }

  return (
    <ContractBlock {...props} className="fees-taxes">
      {getItems}
    </ContractBlock>
  )
}
